import { render, staticRenderFns } from "./ProdutoItem.vue?vue&type=template&id=5201cd13&scoped=true&"
import script from "./ProdutoItem.vue?vue&type=script&lang=js&"
export * from "./ProdutoItem.vue?vue&type=script&lang=js&"
import style0 from "./ProdutoItem.vue?vue&type=style&index=0&id=5201cd13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5201cd13",
  null
  
)

export default component.exports